module.exports = __webpack_public_path__ + "static/christopher-barrat-1161491aafaa004280db39470815126f.jpg";